import React from "react";
import { Theme } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import createStyles from "@mui/styles/createStyles";
import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation, Trans } from "react-i18next";

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			width: "100%",
		},
		alert: {
			width: "80vw",
		},
	})
);

export default function TransitionAlerts(props: any) {
	const classes = useStyles();
	const [open, setOpen] = React.useState(true);
	useTranslation();
	const handleClose = (id: number) => {
		setOpen(false);
		props.deleteAlert(id);
	};
	return (
		<div className={classes.root}>
			<Collapse in={open}>
				<Alert
					severity={props.severity}
					action={
						<IconButton
							aria-label="close"
							color="inherit"
							size="small"
							onClick={() => {
								handleClose(props.id);
							}}
						>
							{props.content ===
							"There are no new alerts at this time" ? null : (
								<CloseIcon color="primary" fontSize="inherit" />
							)}
						</IconButton>
					}
				>
					<Trans>{props.content}</Trans>
				</Alert>
			</Collapse>
		</div>
	);
}
